import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const IN_SOFEST_KEY = "in_sofest_visit";

export default function SofestVisitTracker() {
  const location = useLocation();
  useEffect(() => {
    try {
      if (location.pathname.startsWith("/sofest")) {
        sessionStorage.setItem(IN_SOFEST_KEY, "1");
      } else {
        sessionStorage.removeItem(IN_SOFEST_KEY);
      }
    } catch {
      // ignore privacy-mode / quota errors
    }
  }, [location.pathname]);
  return null;
}
